/*
 * File: OverridenSwitch.tsx
 * Project: beaker
 * -----
 * Last Modified: 17 May 2022 2:27:00 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { message, Switch } from 'antd';
import useModal from 'antd/lib/modal/useModal';
import { ProductCatalogItem } from 'models/ProductCatalog';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateProductCatalogItemMutation } from 'redux/services/julia/juliaApi';

interface Props {
  catalogItem: ProductCatalogItem;
}

export const OverridenSwitch: FC<Props> = ({ catalogItem }) => {
  const { id: customerId } = useParams();

  const [modal, contextHolder] = useModal();

  const uncheckedTitle = 'Are you sure you wish to override this item? All values set in the business will stop synchronizing to the divison';
  const chekcedTitle =
    'Are you sure you want to stop overriding this item? All values will be reverted back to what is set in the business. Note that if this item is not in the busniess, it will be removed from the division';

  const [updateCatalogItem, { isLoading }] = useUpdateProductCatalogItemMutation();

  const handleChange = (checked: boolean): void => {
    if (!customerId) {
      message.error('Unable to override');

      return;
    }

    updateCatalogItem({ customerId, productId: catalogItem.id, payload: { ...catalogItem, ...{ isOverridden: checked } } });
  };
  const handleToggle = (checked: boolean): void => {
    modal.confirm({
      title: checked ? uncheckedTitle : chekcedTitle,
      onOk: () => handleChange(checked)
    });
  };

  return (
    <>
      {contextHolder}
      <Switch checked={catalogItem.isOverridden} onChange={handleToggle} loading={isLoading} />
    </>
  );
};
